module.exports = __webpack_public_path__ + "img/guoqi.7c39cb00.png";